/**
 * 광고 메일(마케팅) 수신 동의 레이어 입니다.
 */
export default class EmailOptInLayer {
  constructor() {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_emailOptInLayer';

    this.render();
  }

  setEvent = () => {
    this.welContainer.on(
      'click',
      `#${this.sWrapper} .popup_button`,
      this.hasMemberEmail ? this.setEmailOptIn : this.openUserInfo
    );
  };

  clearEvent = () => {
    this.welContainer.off('click', `#${this.sWrapper} .popup_button`);
  };

  setHasMemberEmail = hasMemberEmail => {
    this.hasMemberEmail = hasMemberEmail;
  };

  setEmailOptIn = e => {
    e.preventDefault();
    TMON.oApp.oViews.closeLayer();
    TMON.oApp.oApi.fetchApi('putEmailOptIn');
  };

  openUserInfo = e => {
    e.preventDefault();
    TMON.oApp.oViews.closeLayer();

    if (TMON.view_mode === 'app') {
      // TODO urlManager my_chkpwd 모바일 부분 추가 요청 필요
      TMON.app.callApp(
        'webview',
        'showView',
        '마이티몬',
        `${TMON.htDomain.www}/user/info`,
        true,
        false,
        true
      );
    } else {
      window.location.href = `${TMON.htDomain.www}/user/info`;
    }
  };

  open = () => {
    const welMarketing = this.welContainer.find(
      `#${this.sWrapper} .marketing_text`
    );
    if (this.hasMemberEmail) {
      welMarketing.text('혜택을 메일로 받아보세요.');
    } else {
      welMarketing.text('이메일 주소를 등록해주세요.');
    }
    this.clearEvent();
    this.setEvent();

    if (TMON.oApp.sPlatform === 'PW') {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
        bSetHash: false,
        bUseHistorybackOnClose: false,
        bShowDimmed: false,
      });
    } else {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
      });
    }
  };

  render = () => {
    const sHTML = `
            <section id="${this.sWrapper}" class="popup popup_layer popup_marketing">
                <header class="popup_header">
                    <h3 class="popup_header_title">이 상품은 티몬 광고메일을 통해<br>구매 가능한 전용 상품입니다.</h3>
                    <button type="button" class="popup_header_close" data-role="close" aria-label="팝업닫기">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <path fill="#30343B" fill-rule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"></path>
                        </svg>
                    </button>
                </header>
                <div class="popup_contents">
                    <article class="popup_inner">
                        <p class="marketing_text"></p>
                    </article>
                    <div class="popup_buttons">
                        <button type="button" class="popup_button type01">혜택 메일 받기</button>
                    </div>
                </div>
            </section>
        `;

    this.welContainer.append(sHTML);
  };
}
